import {UseMutationOptions, useMutation} from '@tanstack/react-query';
import {API, UserFinalizeResponse, UserInitiatePayload} from '@chekin/api';
import {FastAPIServiceError} from '@chekin/core';
import {useIsMounted} from '@chekin/guestapp-ui-kit';

type Props = UseMutationOptions<
  UserFinalizeResponse,
  FastAPIServiceError,
  UserInitiatePayload
>;
function useGuestAccountTokenMutation({onError, ...props}: Props = {}) {
  const isMounted = useIsMounted();

  return useMutation<UserFinalizeResponse, FastAPIServiceError, UserInitiatePayload>({
    mutationFn: payload => API.auth.getGuestAccountToken(payload),
    onError: (...args) => {
      if (!isMounted.current) {
        return;
      }

      onError?.(...args);
    },
    ...props,
  });
}

export {useGuestAccountTokenMutation};
